<template>
  <div class="modal-content"  >
  <div class="modal-header comment-modal__header">
    <h3 class="comment-modal__title comment-modal__title--mobile">
      {{title}}
    </h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="$emit('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
<section class="modal-body modal-body--big-pd">
  <div class="comment-modal__heading">
    <h3 class="comment-modal__title">
      {{title}}
    </h3>
    <ul class="comment-modal-nav">
      <li class="comment-modal-nav__item" v-for="(tab, index) in tabs" v-if="tab.name">
        <a :href="tab.href" class="comment-modal-nav__link" @click.prevent="selectTab(tab)" :class="{ 'comment-modal-nav__link--active': tab.isActive }">
          {{ tab.name }}
        </a>
      </li>
    </ul>
  </div>
  <div class="comment-modal__common" v-if="!auth">
    <social-auth :building_id="building_id"></social-auth>
  </div>
  <div class="comment-modal__details">
    <slot name="description"></slot>
  </div>
</section>
  </div>
</template>
<script>
import SocialAuth from "./social-auth";
export default {
  components:{
    SocialAuth
  },
  props: {
    building_id:Number,
    auth:Boolean,
  },
  data() {
    return {
      tabs: [],
      title:"",
    }
  },
  created() {

    this.tabs = this.$children;
    console.log(this.tabs)

  },
  methods: {
    selectProfile() {
      this.tabs[0]['isActive'] = false;
      this.tabs[1]['isActive'] = true
    },
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name == selectedTab.name);
        this.title = selectedTab.name
      });
    }
  },
  mounted() {
    this.tabs.forEach(tab => {
     if(tab.isActive ===true) {
       if(tab.name === 'Войти') {
         this.title = 'Вход в аккаунт';
       } else {
         this.title = tab.name
       }

     }

    });
  }
}
</script>